import { render, staticRenderFns } from "./ElectrocardiographyPanel.vue?vue&type=template&id=7ec1c810&scoped=true&"
import script from "./ElectrocardiographyPanel.vue?vue&type=script&lang=js&"
export * from "./ElectrocardiographyPanel.vue?vue&type=script&lang=js&"
import style0 from "./ElectrocardiographyPanel.vue?vue&type=style&index=0&id=7ec1c810&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec1c810",
  null
  
)

export default component.exports